import { Navigate, Outlet } from 'react-router-dom'
import { ROUTES } from '@/constants'

type Props = {
  isAvailableFormSubmission: boolean
}

export const ProtectedFormSubmission = ({ isAvailableFormSubmission }: Props) =>
  isAvailableFormSubmission ? <Outlet /> : <Navigate to={ROUTES.home} />
